export enum EmptyStateType {
    SuggestedFriends = 'SuggestedFriends',
    SearchFriends = 'SearchFriends',
    MyFriends = 'MyFriends'
}
